import FeaturesMap from '@apps-common/ui-maps/FeaturesMap';
import GeojsonLayer from '@apps-common/ui-maps/GeojsonLayer';
import {pink} from '@mui/material/colors';
import {object} from 'prop-types';
import React from 'react';

export const CompareMap = ({geometry, candidate}) => {
  return (
    <FeaturesMap
      features={[
        {
          type: 'Feature',
          geometry,
        },
      ]}
      allowInteractions={false}
      showMapControls={false}
      animationDuration={0}
      featuresStyle={{
        'stroke-color': `${pink[500]}`,
        'stroke-width': 3,
        'fill-color': `${pink[300]}66`,
      }}
    >
      <GeojsonLayer
        features={[
          {
            type: 'Feature',
            geometry: candidate.geometry,
          },
        ]}
      />
    </FeaturesMap>
  );
};

CompareMap.propTypes = {
  candidate: object.isRequired,
  geometry: object.isRequired,
};
